import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 重写 push/replace：vue-router 3.x 中，导航被取消（重复跳转/被新导航打断）会抛出未捕获的 Promise 错误，这里静默处理
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => {
        if (isNavigationFailure(err)) return err
        return Promise.reject(err)
    })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => {
        if (isNavigationFailure(err)) return err
        return Promise.reject(err)
    })
}

// 导航失败类错误（重复导航、导航被取消/中断），非真实异常
function isNavigationFailure(err) {
    if (!err) return false
    if (err.name === 'NavigationDuplicated') return true
    return /Navigation cancelled|Navigation aborted|Navigation interrupted/.test(err.message || '')
}

const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/login',
        component: () => import('@/views/login/login.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/front/Home.vue'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/productService',
        name: 'ProductService',
        component: () => import('@/views/front/ProductService.vue'),
        meta: {
            title: '产品'
        }
    },
    {
        path: '/productDetail/:id',
        name: 'ProductDetail',
        component: () => import('@/views/front/components/ProductDetail.vue'),
        props: true
    },
    {
        path: '/page/:id',
        name: 'Page',
        component: () => import('@/views/front/Page.vue'),
        props: true
    },
    {
        path: '/maybe',
        name: 'Admin',
        component: () => import('@/views/admin/Index.vue'),
        meta: {
            title: '后台首页'
        },
        children: [
            {
                path: '/password',
                name: 'Password',
                component: () => import('@/views/admin/Password.vue'),
                meta: {
                    title: '修改密码'
                }
            },
            {
                path: '/info',
                name: 'Info',
                component: () => import('@/views/admin/Info.vue'),
                meta: {
                    title: '基本信息'
                }
            },
            // {
            //     path: '/brands',
            //     name: 'Brands',
            //     component: () => import('@/views/admin/Brands.vue'),
            //     meta: {
            //         title: '品牌配置'
            //     }
            // },
            {
                path: '/products',
                name: 'Products',
                component: () => import('@/views/admin/Products.vue'),
                meta: {
                    title: '产品管理'
                }
            },
            {
                path: '/addProduct',
                name: 'AddProduct',
                component: () => import('@/views/admin/AddProduct.vue'),
                meta: {
                    title: '添加产品'
                }
            },
            {
                path: '/banner',
                name: 'Banner',
                component: () => import('@/views/admin/BannerManage.vue'),
                meta: {
                    title: '轮播图配置'
                }
            },
            {
                path: '/carousel',
                name: 'Carousel',
                component: () => import('@/views/admin/ProductsCarousels.vue'),
                meta: {
                    title: '横向产品配置'
                }
            },
            {
                path: '/pages',
                name: 'Pages',
                component: () => import('@/views/admin/Pages.vue'),
                meta: {
                    title: '图文页管理'
                }
            },
            {
                path: '/certificate',
                name: 'certificate',
                component: () => import('@/views/admin/Certificate.vue'),
                meta: {
                    title: '品牌授权证书配置'
                }
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router

export function resetRouter() {
    router.push({ path: '/login' })
}
